import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12.388",
      r: "12",
      fill: "#D3231B"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FDEFEE",
      "fill-rule": "evenodd",
      d: "M12 15.26c-.787 0-1.334.504-1.334 1.23 0 .727.547 1.23 1.334 1.23s1.333-.503 1.333-1.23c0-.726-.546-1.23-1.333-1.23m.485-8.206h-.97c-.636 0-.865.157-.848.626l.177 6.133c.018.47.212.626.847.626h.618c.635 0 .83-.157.847-.626l.176-6.133c.018-.47-.212-.626-.847-.626",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }